import React from "react";
import {
  Datagrid,
  DateField,
  Filter,
  ImageField,
  ImageInput,
  List,
  NumberInput,
  ReferenceField,
  SelectInput,
  SimpleShowLayout,
  TextField,
  ReferenceInput,
  TextInput,
  required,
} from "react-admin";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import Emoji from "../../components/Emoji";

const TaskFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput alwaysOn label="Plan" source="planId" reference="plan" sort={{field: 'title', order:'ASC'}}>
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
  </Filter>
);

export const TaskList = (props) => (
  <List {...props} filters={<TaskFilter/>} perPage={60}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
      <DateField showTime={true} source="createdAt"/>
      <DateField showTime={true} source="updatedAt"/>
      <ImageField source="icon"/>
      <TextField source="title"/>
      <TextField source="title_fr"/>
      <TextField source="title_de"/>
      <TextField source="title_nl"/>
      <TextField source="title_es"/>
      <TextField source="title_pt"/>
      <ReferenceField link="show" label="Plan" source="planId" reference="plan" >
        <TextField source="title"/>
      </ReferenceField>
      <TextField source="order"/>
    </Datagrid>
  </List>
);

export const TaskEdit = (props) => (
  <EditView {...props} perPage={10}>
    <ReferenceInput label="Plan" validate={required()} source="planId" reference="plan">
      <SelectInput optionText="title" alwaysOn/>
    </ReferenceInput>
    <TextInput source="title" validate={required()}/>
    <TextInput source="title_fr" />
    <TextInput source="title_de" />
    <TextInput source="title_nl" />
    <TextInput source="title_es" />
    <TextInput source="title_pt" />
    <NumberInput source="order" validate={required()}/>
    <Emoji source="description" label="Description" />
    <Emoji source="description_fr" label="Description FR" />
    <Emoji source="description_de" label="Description DE" />
    <Emoji source="description_nl" label="Description NL" />
    <Emoji source="description_es" label="Description ES" />
    <Emoji source="description_pt" label="Description PT" />
    <Emoji source="descriptionHt" label="Description for hormone therapy" />
    <Emoji source="descriptionHt_fr" label="Description for hormone therapy FR" />
    <Emoji source="descriptionHt_de" label="Description for hormone therapy DE" />
    <Emoji source="descriptionHt_nl" label="Description for hormone therapy NL" />
    <Emoji source="descriptionHt_es" label="Description for hormone therapy ES" />
    <Emoji source="descriptionHt_pt" label="Description for hormone therapy PT" />
    <NumberInput source="order"/>
    <ImageInput source="pictures"  label="Image" accept="image/*">
      <ImageField source="src" title="title"/>
    </ImageInput>
    <TextInput source="icon" validate={required()}/>
  </EditView>
);

export const TaskShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <ImageField source="icon"/>
      <TextField source="objectId"/>
      <TextField source="title"/>
      <TextField source="title_fr"/>
      <TextField source="title_de"/>
      <TextField source="title_nl"/>
      <TextField source="title_es"/>
      <TextField source="title_pt"/>
      <TextField source="description"/>
      <TextField source="description_fr"/>
      <TextField source="description_de"/>
      <TextField source="description_nl"/>
      <TextField source="description_es"/>
      <TextField source="description_pt"/>
      <TextField source="descriptionHt"/>
      <TextField source="descriptionHt_fr"/>
      <TextField source="descriptionHt_de"/>
      <TextField source="descriptionHt_nl"/>
      <TextField source="descriptionHt_es"/>
      <TextField source="descriptionHt_pt"/>
      <DateField showTime={true} source="createdAt"/>
      <DateField showTime={true} source="updatedAt"/>
      <ReferenceField link="show" label="Plan" source="planId" reference="plan" >
        <TextField source="title"/>
      </ReferenceField>
      <TextField source="order"/>
    </SimpleShowLayout>
  </ShowView>
);

export const TaskCreate = (props) => (
  <CreateView {...props}>
    <ReferenceInput label="Plan" source="planId" validate={required()} reference="plan">
      <SelectInput optionText="title"  alwaysOn/>
    </ReferenceInput>
    <TextInput source="title" validate={required()}/>
    <TextInput source="title_fr" />
    <TextInput source="title_de" />
    <TextInput source="title_nl" />
    <TextInput source="title_es" />
    <TextInput source="title_pt" />
    <Emoji source="description" label="Description" />
    <Emoji source="description_fr" label="Description FR" />
    <Emoji source="description_de" label="Description DE" />
    <Emoji source="description_nl" label="Description NL" />
    <Emoji source="description_es" label="Description ES" />
    <Emoji source="description_pt" label="Description PT" />
    <Emoji source="descriptionHt" label="Description for hormone therapy " />
    <Emoji source="descriptionHt_fr" label="Description for hormone therapy FR" />
    <Emoji source="descriptionHt_de" label="Description for hormone therapy DE" />
    <Emoji source="descriptionHt_nl" label="Description for hormone therapy NL" />
    <Emoji source="descriptionHt_es" label="Description for hormone therapy ES" />
    <Emoji source="descriptionHt_pt" label="Description for hormone therapy PT" />
    <NumberInput source="order"/>
    <ImageInput source="pictures" validate={required()} label="Image" accept="image/*">
      <ImageField source="src" validate={required()} title="title"/>
    </ImageInput>
  </CreateView>
);
